import * as React from 'react';
import { Content } from './About.styles'

const About = () => {
    return (
        <Content>
            <p>Dzięki swojej zaawansowanej technologii stałej częstotliwości 448kHZ fali radiowej, urządzenie marki INDIBA® S.A intensywnie stymuluje i regeneruje tkanki przyspieszając ich gojenie. <br/><br/>
            Dodatkowo sprzęt wykorzystuje jedyny na świecie, opatentowany system Proionic®, który poprawia krążenie płynów międzytkankowych i wymianę międzykomórkową. Przekłada się to bezpośrednio na stymulowanie syntezy kolagenu i elastyny, zmniejszenie bólu, obrzęku i napięcia tkanek. <br/><br/> 
            Dzięki możliwości działania atermicznego leczenie urazów czy ran można rozpocząć już w ostrej fazie.</p>
        </Content>
  
    )
}

export default About; 